<template>
  <div class="register-success">
    <div class="card p-5">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="circle-step"><i class="fas fa-check"></i></div>
      <div class="mt-2 text-center">
        <h3 class="fc-dark-blue">
          ลงทะเบียนสำเร็จ
        </h3>
        <p>ระบบได้รับข้อมูลการลงทะเบียนของท่านเรียบร้อยแล้ว</p>
        <p>
          ท่านจะได้รับข้อมูลบัญชีสำหรับเข้าใช้งานระบบ Data Tagging ทาง email:
          <a href="#" @click.prevent>{{user.email}}</a> ที่ลงทะเบียนไว้
        </p>
      </div>
    </div>

      <div class="mt-2 mb-2">
        <h6 class="font-weight-bold fc-dark-blue">
          ตำแหน่งงาน: Data Tagging (บริษัท อินไซท์เอรา จำกัด)
        </h6>
        <div class="card">
          <div class="card-header">
            <p class="font-weight-bold">ข้อมูลส่วนตัว</p>
          </div>
          <div class="card-body">
            <table>
              <tr>
                <td>ชื่อ-นามสกุล (ไทย):</td>
                <td>{{userInfo.fullname_th}}</td>
              </tr>

              <tr>
                <td>ชื่อ-นามสกุล (อังกฤษ):</td>
                <td>{{userInfo.fullname_en}}</td>
              </tr>

              <tr>
                <td>เบอร์โทรศัพท์:</td>
                <td>{{userInfo.accountInfo.phone}}</td>
              </tr>

              <tr>
                <td>Email:</td>
                <td>{{userInfo.email}}</td>
              </tr>

              <tr>
                <td>วัน/เดือน/ปีเกิด (ค.ศ.):</td>
                <td>{{userInfo.birth_date}}</td>
              </tr>

              <tr>
                <td>เลขประจำตัวประชาชน:</td>
                <td>{{userInfo.accountInfo.id_card}}</td>
              </tr>

              <tr>
                <td>ธนาคาร:</td>
                <td>{{userInfo.accountInfo.bank}}</td>
              </tr>

              <tr>
                <td>เลขที่บัญชีธนาคาร:</td>
                <td>{{userInfo.accountInfo.bank_account}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="card mt-3">
          <div class="card-header">
            <p class="font-weight-bold">ข้อมูลที่อยู่</p>
          </div>
          <div class="card-body">
            <table>
              <tr>
                <td>ที่อยู่:</td>
                <td>
                  {{userInfo.accountInfo.document_address}} {{userInfo.accountInfo.document_subdistrict}} {{userInfo.accountInfo.document_district}} {{userInfo.accountInfo.document_province}} {{userInfo.accountInfo.document_postcode}}
                </td>
              </tr>

              <tr>
                <td>ลักษณะที่อยู่:</td>
                <td>{{userInfo.accountInfo.live_with}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="card mt-3">
          <div class="card-header">
            <p class="font-weight-bold">บุคคลอ้างอิง</p>
          </div>
          <div class="card-body">
            <table>
              <tr>
                <td>ชื่อ-นามสกุล</td>
                <td>{{userInfo.referal_fullname_th}}</td>
              </tr>

              <tr>
                <td>ความสัมพันธ์:</td>
                <td>{{userInfo.accountInfo.referal_relation}}</td>
              </tr>

              <tr>
                <td>เบอร์โทรศัพท์:</td>
                <td>{{userInfo.accountInfo.referal_phone}}</td>
              </tr>

              <tr>
                <td>Email:</td>
                <td>{{userInfo.accountInfo.referal_email ? userInfo.accountInfo.referal_email : '-'}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div>
        <span class="font-weight-bold fc-dark-blue">หมายเหตุ:</span>
        หากต้องการสอบถามเพิ่มเติมหรือแก้ไขข้อมูล กรุณาติดต่อเราได้ที่ email:
        <a href="mailto:data-tagging@insightera.co.th"
          >data-tagging@insightera.co.th</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    user: Object
  },
  computed: {
    userInfo () {
      let userInfo = this.user
      if (userInfo) {
        userInfo.fullname_th = `${userInfo.accountInfo.firstname_th} ${userInfo.accountInfo.lastname_th}`
        userInfo.fullname_en = `${userInfo.accountInfo.firstname_en} ${userInfo.accountInfo.lastname_en}`
        userInfo.birth_date = moment(userInfo.accountInfo.birth_date).format('DD/MM/YYYY')

        userInfo.referal_fullname_th = `${userInfo.accountInfo.referal_firstname_th} ${userInfo.accountInfo.referal_lastname_th}`
      }

      return userInfo
    }
  }
}
</script>

<style scoped>
.card h6 {
  color: #141b4d;
}
.register-success {
  padding: 3rem 10rem;
  background-color: #f9fafe;
}
table tr td:first-child{
  min-width: 200px;
}

.circle-step {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  border: 2px solid #25b372;
  background-color: #25b372;
}

.card-header {
  color:#141B4D;
}
</style>
